<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>就位费用报销申请使用说明:<br>
					<span>1、单号构成规则:201201+JW+4位顺序号。系统生成,添加无效</span><br>
					<span>2、提交后递交给财务审核。</span><br>
					<span>3、查询关键字:单号、车牌、收款人。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->
		</pre-base>

	</div>
</template>

<script>
	import {
		GetShort
	} from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_tab.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "applyjw",
					"title": "就位费用报销",
					"isTwo": "1",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"sel_action": 'exp_cw_jw_apply_m',
					"upd_action": 'exp15_cw_jw_apply_m',
					"tab_name_1": "明细费用",
					"tab_name_2": "人员费用",
					"detail_part": "1",
					"detail_excelup": "1",
					"d_btn_more": "0",
					"d_sel_action": 'exp_cw_jw_apply_d1',
					"d_upd_action": '_cw_jw_apply_d1',
					"d_sel_action2": 'exp_cw_jw_apply_d2',
					"d_upd_action2": '_cw_jw_apply_d2',
					"file_action": 'jw_apply',
					"p1": 'caiwu',
					"p2": 'jwapply',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"sel": "2"
						},
						{
							"name": "收款人",
							"val": "",
							"key": "u_name",
							"type": "text",
							"class": "long1",
							"sel": "3"
						}
					],
					"parm": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "运单号",
							"val": "",
							"key": "sheet_ys",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "1",
							"r": '0',
							"w": '1'
						},
						{
							"name": "订单号",
							"val": "",
							"key": "order_no",
							"type": "text",
							"r": '1',
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "厂家名称",
							"val": "",
							"key": "c_name",
							"type": "text",
							"r": '1',
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						{
							"name": "发货日期",
							"val": "",
							"key": "s_date",
							"type": "text",
							"class": "long1 ",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "1"
						},
						// {
						// 	"name": "结束日期",
						// 	"val": "",
						// 	"key": "e_date",
						// 	"type": "text",
						// 	"class": "long1 ",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "1"
						// },
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"class": "long1",
							"type": "text",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "车挂",
							"val": "",
							"key": "car_no",
							"class": "long1",
							"type": "text",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "司机",
							"val": "",
							"key": "driver",
							"class": "long1",
							"type": "text",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "起点",
							"val": "",
							"key": "s_addr",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "终点",
							"val": "",
							"key": "e_addr",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "货物名称",
							"val": "",
							"key": "item_up_name",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "3"
						},
						{
							"name": "规格",
							"val": "",
							"key": "item_up_size",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "3"
						},
						{
							"name": "重量",
							"val": "",
							"key": "item_up_weight",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "3"
						},
						// {
						// 	"name": "ETC卡消费",
						// 	"val": "",
						// 	"key": "etc_pay",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "4"
						// },
						// {
						// 	"name": "ETC现金消费",
						// 	"val": "",
						// 	"key": "etc_xj",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "4"
						// },
						{
							"name": "油卡期初",
							"val": "",
							"key": "oil_start",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "4"
						},
						{
							"name": "油卡消费",
							"val": "",
							"key": "oil_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						{
							"name": "现金购油",
							"val": "",
							"key": "oil_money",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "4"
						},
						// {
						// 	"name": "油卡够尿素",
						// 	"val": "",
						// 	"key": "ns_pay",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "4"
						// },
						// {
						// 	"name": "现金购尿素",
						// 	"val": "",
						// 	"key": "ns_money",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "4"
						// },
						// {
						// 	"name": "罚款",
						// 	"val": "",
						// 	"key": "fk_pay",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "5"
						// },
						// {
						// 	"name": "停车费",
						// 	"val": "",
						// 	"key": "tcf_pay",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "5"
						// },

						// {
						// 	"name": "维修费",
						// 	"val": "",
						// 	"key": "wh_pay",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "5"
						// },
						// {
						// 	"name": "打车费",
						// 	"val": "",
						// 	"key": "dache_pay",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "5"
						// },

						{
							"name": "住宿费",
							"val": "",
							"key": "zhusu_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "5"
						},
						{
							"name": "生活费",
							"val": "",
							"key": "day_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "5"
						},
						// {
						// 	"name": "过路费",
						// 	"val": "",
						// 	"key": "glf_pay",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "5"
						// },
						// {
						// 	"name": "吊装费",
						// 	"val": "",
						// 	"key": "dz_amount",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "6"
						// },
						// {
						// 	"name": "倒运费",
						// 	"val": "",
						// 	"key": "dy_amount",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "6"
						// },
						// {
						// 	"name": "装车费",
						// 	"val": "",
						// 	"key": "zc_amount",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "6"
						// },
						// {
						// 	"name": "卸车费",
						// 	"val": "",
						// 	"key": "xc_amount",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": '0',
						// 	"r": '1',
						// 	"x": "6"
						// },
						{
							"name": "工资",
							"val": "",
							"key": "gongzi_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "5"
						},
						{
							"name": "其他费用",
							"val": "",
							"key": "qt_pay",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "5"
						},
						{
							"name": "收入",
							"val": "",
							"key": "amount_in",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "6"
						},
						{
							"name": "支出",
							"val": "",
							"key": "amount_out",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "6"
						},
						{
							"name": "预支",
							"val": "",
							"key": "amount_bef",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "6"
						},
						{
							"name": "报销合计",
							"val": "",
							"key": "amount",
							"type": "text",
							"class": "long1",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "6"
						},
						
						{
							"name": "领队",
							"val": "",
							"key": "lingdui",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"p": "1",
							"w": '1',
							"r": '0',
							"x": "7"
						},
						{
							"name": "收款人",
							"val": "",
							"key": "rec_user",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "7"
						},
						{
							"name": "收款人账号",
							"val": "",
							"key": "rec_card",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "7"
						},
						{
							"name": "备注",
							"val": "",
							"key": "p_note",
							"type": "text",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "8"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "运单号"
						},
						{
							"name": "订单号"
						},
						{
							"name": "厂家名称"
						},
						{
							"name": "发货日期"
						},
						// {
						// 	"name": "结束日期"
						// },
						{
							"name": "状态"
						},
						{
							"name": "车牌"
						},
						{
							"name": "车挂"
						},
						{
							"name": "司机"
						},
						{
							"name": "起点"
						},
						{
							"name": "终点"
						},
						{
							"name": "货物名称"
						},
						{
							"name": "规格"
						},
						{
							"name": "重量"
						},
						// {
						// 	"name": "剩余距离"
						// },
						// {
						// 	"name": "ETC卡消费"
						// },
						// {
						// 	"name": "ETC现金消费"
						// },
						{
							"name": "油卡期初"
						},
						{
							"name": "油卡消费"
						},
						{
							"name": "现金购油"
						},
						// {
						// 	"name": "油卡购尿素"
						// },
						// {
						// 	"name": "现金购尿素"
						// },
						// {
						// 	"name": "罚款"
						// },
						// {
						// 	"name": "停车费"
						// },

						// {
						// 	"name": "维护费"
						// },
						// {
						// 	"name": "打车费"
						// },

						{
							"name": "住宿费"
						},
						{
							"name": "生活费"
						},

						// {
						// 	"name": "过路费"
						// },
						// {
						// 	"name": "吊装费"
						// },
						// {
						// 	"name": "倒运费"
						// },
						// {
						// 	"name": "装车费"
						// },
						// {
						// 	"name": "卸车费"
						// },
						{
							"name": "人员费用"
						},
						{
							"name": "其他费用"
						},
						{
							"name": "现金消费合计"
						},
						{
							"name": "领队"
						},
						{
							"name": "收入"
						},
						{
							"name": "支出"
						},
						{
							"name": "预支付"
						},
						{
							"name": "报销合计"
						},
						{
							"name": "收款人"
						},
						{
							"name": "收款人账号"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},
						{
							"name": "修改人"
						},

						{
							"name": "浏览地址"
						},
						{
							"name": "存储地址"
						},
						{
							"name": "修改时间"
						}
					],
					"d_parm": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "费用名称",
							"val": "",
							"key": "pay_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_base_ys_pay",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "金额",
							"val": "",
							"key": "pay_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "油卡卡号",
							"val": "",
							"key": "pay_no",
							"type": "text",
							"class": "long1",
							"note": "油卡消费必填",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "支付日期",
							"val": "",
							"key": "pay_date",
							"type": "date",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "支付类型",
							"val": "支出",
							"key": "pay_io",
							"type": "select",
							"list": [
								{
								"id": "1",
								"val": "收入"
							}, 
							{
								"id": "2",
								"val": "支出"
							}],
							"sel_name": "",
							"sel_val": {},
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "是否开票",
							"val": "",
							"key": "is_paper",
							"type": "select",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "0"
						},
						{
							"name": "公司支付",
							"val": "否",
							"key": "is_pay",
							"type": "select",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "0"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "金额"
						},
						{
							"name": "油卡卡号"
						},
						{
							"name": "支付日期"
						},
						{
							"name": "收入|支出"
						},
						{
							"name": "是否开票"
						},
						{
							"name": "公司已支付"
						},
						{
							"name": "备注",
							"class": "long2"
						},

						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						// 	"name": "路径1"
						// },
						// {
						// 	"name": "路径2"
						// },
						{
							"name": "更新时间",
							"class": "long2"
						}
					],
					"d_parm2": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},

						{
							"name": "人员数量",
							"val": "",
							"key": "user_num",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "费用/人",
							"val": "",
							"key": "user_pay",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "日期",
							"val": "",
							"key": "user_date",
							"type": "date",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "公司已支付",
							"val": "否",
							"key": "is_pay",
							"type": "select",
							"sel_action": "data_base_ispay",
							"sel_name": "",
							"note": "否",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "人员名单",
							"val": "",
							"key": "user_list",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "user_note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name2": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "人员名单"
						},
						{
							"name": "人数"
						},
						{
							"name": "每人费用"
						},
						{
							"name": "日期"
						},
						{
							"name": "公司已支付"
						},
						{
							"name": "备注",
							"class": "long2"
						},

						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						// 	"name": "路径1"
						// },
						// {
						// 	"name": "路径2"
						// },
						{
							"name": "更新时间",
							"class": "long2"
						}
					]

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}



		}
	};
</script>
<style>
</style>
